<template>
  <div class="ma-site-header">
    <div class="announcement">
      <span>Découvrez la nouvelle expérience Minds' Academy</span>
      <router-link :to="{ name: 'minds-register' }">
        Explorer la plateforme <span aria-hidden="true">→</span>
      </router-link>
    </div>

    <header class="site-header">
      <router-link
        :to="{ name: 'home' }"
        class="brand"
        aria-label="Minds' Academy — Accueil"
      >
        <img
          src="/minds-academy-lockup.png"
          alt="Minds' Academy"
        >
      </router-link>

      <nav
        class="desktop-nav"
        aria-label="Navigation principale"
      >
        <router-link :to="{ name: 'videos' }">
          Nos vidéos
        </router-link>
        <router-link :to="{ name: 'phototheque' }">
          Photothèque
        </router-link>
        <router-link :to="{ name: 'home', hash: '#temoignage' }">
          Pourquoi Minds' Academy
        </router-link>
        <router-link :to="{ name: 'home', hash: '#temoignages-etudiants' }">
          Témoignages
        </router-link>
      </nav>

      <div class="header-actions">
        <router-link
          :to="{ name: 'login-student' }"
          class="login-link"
        >
          Se connecter
        </router-link>
        <router-link
          :to="{ name: 'minds-register' }"
          class="header-signup"
        >
          S'inscrire
        </router-link>
      </div>

      <button
        type="button"
        class="menu-toggle"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-label="Ouvrir le menu"
        @click="menuOpen = !menuOpen"
      >
        <span />
        <span />
        <span />
      </button>

      <div
        v-if="menuOpen"
        class="mobile-nav"
      >
        <router-link
          :to="{ name: 'videos' }"
          @click.native="menuOpen = false"
        >
          Nos vidéos
        </router-link>
        <router-link
          :to="{ name: 'phototheque' }"
          @click.native="menuOpen = false"
        >
          Photothèque
        </router-link>
        <router-link
          :to="{ name: 'home', hash: '#temoignage' }"
          @click.native="menuOpen = false"
        >
          Pourquoi Minds' Academy
        </router-link>
        <router-link
          :to="{ name: 'home', hash: '#temoignages-etudiants' }"
          @click.native="menuOpen = false"
        >
          Témoignages
        </router-link>
        <router-link
          :to="{ name: 'login-student' }"
          @click.native="menuOpen = false"
        >
          Se connecter
        </router-link>
        <router-link
          :to="{ name: 'minds-register' }"
          class="mobile-signup"
        >
          S'inscrire
        </router-link>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      menuOpen: false,
    }
  },
}
</script>

<style scoped>
.ma-site-header {
  --cream: #fffaf3;
  --ink: #100707;
  --teal: #18b9a7;
  --teal-dark: #0d756c;
  --coral: #ff6f59;
  --violet: #602bd9;
  font-family: Inter, "Helvetica Neue", Arial, sans-serif;
  color: var(--ink);
}

.ma-site-header a {
  color: inherit;
  text-decoration: none;
}

.announcement {
  min-height: 46px;
  padding: 10px 5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  background: var(--violet);
  color: #fff;
  font-size: 15px;
}

.announcement a {
  color: #ff9b8d;
  font-weight: 800;
  text-decoration: underline;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 60;
  min-height: 88px;
  padding: 12px clamp(24px, 5vw, 82px);
  display: flex;
  align-items: center;
  gap: 34px;
  background: rgba(255, 250, 243, 0.96);
  border-bottom: 1px solid rgba(16, 7, 7, 0.09);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.brand {
  width: 180px;
  height: 58px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.brand img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: clamp(18px, 2vw, 36px);
  font-size: 14px;
  font-weight: 650;
}

.desktop-nav a,
.login-link {
  position: relative;
}

.desktop-nav a::after,
.login-link::after {
  position: absolute;
  right: 0;
  bottom: -6px;
  left: 0;
  height: 2px;
  background: var(--coral);
  content: "";
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.22s ease;
}

.desktop-nav a:hover::after,
.login-link:hover::after {
  transform: scaleX(1);
}

.header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 22px;
  font-size: 14px;
  font-weight: 750;
}

.header-signup,
.mobile-signup {
  padding: 13px 20px;
  border-radius: 999px;
  background: var(--coral);
  color: #fff !important;
  border: 1px solid var(--coral);
  font-weight: 800;
  transition: 0.2s ease;
}

.header-signup:hover,
.mobile-signup:hover {
  filter: brightness(0.94);
  box-shadow: 0 8px 22px rgba(255, 111, 89, 0.32);
}

.header-signup::after {
  display: none;
}

.menu-toggle,
.mobile-nav {
  display: none;
}

@media (max-width: 1100px) {
  .desktop-nav,
  .header-actions {
    display: none;
  }

  .menu-toggle {
    width: 42px;
    height: 42px;
    margin-left: auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: 6px;
    background: transparent;
    border: 0;
    cursor: pointer;
  }

  .menu-toggle span {
    height: 2px;
    background: var(--ink);
  }

  .site-header {
    position: relative;
  }

  .mobile-nav {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    padding: 26px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: var(--cream);
    border-bottom: 1px solid var(--ink);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
    font-weight: 750;
    z-index: 60;
  }
}

@media (max-width: 700px) {
  .announcement {
    padding: 10px 18px;
    flex-direction: column;
    gap: 2px;
    text-align: center;
  }

  .site-header {
    min-height: 76px;
    padding: 8px 18px;
  }

  .brand {
    width: 145px;
    height: 52px;
  }
}
</style>
